import React from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({ text }) => {
  return (
    <div className="relative inline-block group">
      <span
        className="material-icons icon-button cursor-pointer"
        translate="no"
      >
        help_outline
      </span>
      <div className="absolute bg-neutral-0 p-8 top-0 left-full ml-3 w-[316px] rounded shadow-[0_5px_10px_0_rgba(0,0,0,0.15)] border border-neutral-300 bg-white z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none text-xs text-neutral-900 leading-[1.33]">
        {text}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string,
};

export default Tooltip;
